const LegacyIcon = ({ src }: { src: string }) => (
  <img src={src} alt="" css="width: 0.9375rem; height: 0.9375rem;" />
);

export default LegacyIcon;
